/**
 * Created by Jodie on 2019/5/08.
 */
//import Vue from 'vue'
import axios from 'axios'
import Common from "./appCommon.js"
import jQuery from 'jquery'

var service = {};

window.SERVER_BASE = process.env.SERVER_API;
console.log(window.SERVER_BASE);

service.serverUrl = window.SERVER_BASE;

axios.defaults.timeout = 60000;                   //响应时间
axios.defaults.baseURL = window.SERVER_BASE;   //配置接口地址
axios.defaults.withCredentials = true;
axios.defaults.responseType='json';
axios.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';
axios.defaults.headers.get['Cache-Control'] = 'no-cache';
axios.defaults.headers.get['Pragma'] = 'no-cache';
axios.defaults.headers.get['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

//添加请求拦截器
axios.interceptors.request.use(function (config) {
  //Common.Preloader.show();
  return config;
}, function (error) {
  //Common.PageOperator.showPromptMsg(true,"错误的传参");
  //Common.Preloader.hidden();
  return Promise.reject(error);
});

//添加响应拦截器
axios.interceptors.response.use(function (response) {
  //Common.Preloader.hidden();
  return response;
}, function (error) {
  //Common.PageOperator.showPromptMsg(true,"网络异常");
  //Common.Preloader.hidden();
  return Promise.reject(error);
});

/**  Before Send the request filter **/
service.beforeRequest = function (vm, url, urlData) {
  url = Common.Request.beforeSend(vm, url, urlData);
  return url;
};

/**  After Send the request filter **/
service.afterRequest = function (vm, url, postData, promise) {
  var deferred = jQuery.Deferred();
  promise.then(function (response) {
    var handleResult = Common.Request.afterResponse(vm, response.data, url, postData);
    if(handleResult != "abort") {
      deferred.resolve(handleResult);
    } else {
      deferred.reject("系统已处理");
    }
  }, function(response) {
    var errorMsg = (response==null ? "无法连接服务器" : response);
    if(response)
    {
      if(Common.Util.isString(response) && response.indexOf(" - Error report<\/title>")>0)
      {
        var getContent = function(startStr, endStr) {
          var posStart = response.indexOf(startStr);
          if(posStart > 0){
            var posEnd = response.indexOf(endStr, posStart);
            if(posEnd > 0){
              var content = response.substring(posStart+startStr.length, posEnd);
              return content;
            }
          }
          return "";
        };
        errorMsg = "错误标题：" + getContent("<body><h1>", "</h1>") + "\r\n"
          + "错误类型：" + getContent("<p><b>type</b>", "</p>").replace("<u>","") + "\r\n"
          + "错误消息：" + getContent("<b>message</b>", "</u>").replace("<u>","") + "\r\n"
          + "错误描述：" + getContent("<b>description</b>", "</u>").replace("<u>","") + "\r\n";
      }
      if(Common.Util.isObject(response) && Common.Util.isString(response.message))
      {
        errorMsg = response.message;
      }
    }
    alert(errorMsg);
    deferred.reject(response);
  });
  return deferred.promise();
};

/**
 *
 * @param vm
 * @param url
 * @param postData
 * @param urlData
 */
service.postForm = function (vm, url, urlData, postData) {
  url = service.beforeRequest(vm, url, urlData);
  var promise = axios.post(url, postData, {headers:{
    'Content-Type':'application/x-www-form-urlencoded'
  }});
  return service.afterRequest(vm, url, postData, promise);
};

/**
 *
 * @param vm
 * @param url
 * @param postData
 * @param urlData
 */
service.postFile = function (vm, url, urlData, postData) {
  url = service.beforeRequest(vm, url, urlData);
  var promise = axios.post(url, postData, {headers:{'Content-Type':'multipart/form-data'}});
  return service.afterRequest(vm, url, postData, promise);
};

/**
 *
 * @param vm
 * @param url
 * @param postData
 * @param urlData
 * @param config
 */
service.post = function (vm, url, postData, urlData, config) {
  url = service.beforeRequest(vm, url, urlData);
  var promise = axios.post(url, postData, config);
  return service.afterRequest(vm, url, postData, promise);
};

/**
 *
 * @param vm
 * @param url
 * @param urlData
 */
service.get = function (vm, url, urlData) {
  url = service.beforeRequest(vm, url, urlData);
  var promise = axios.get(url);
  return service.afterRequest(vm, url, null, promise);
};

export default service;



// WEBPACK FOOTER //
// ./src/js/appService.js